import styled from "styled-components";

import PrimaryButton from "./PrimaryButton";

interface Props{
  $hasError?: Boolean;
}

const SecondaryButton = styled(PrimaryButton)<Props>`
  align-items: center;
  background: white;
  border: 1px solid ${(props) => props.disabled || props.$hasError ? "#bdbdbd" : "#D9D9D9"};
  border-radius: 8px;
  color: ${(props) => props.disabled || props.$hasError ? "#bdbdbd" : "black"};
  display: flex;
  flex-direction: column;
  font-family: Inter, Oxygen, Roboto, sans-serif;
  font-size: 16px;
  gap: 0px;
  justify-content: center;
  line-height: 24px;
  padding: 12px;
  position: relative;
  text-align: left;
  width: 240px;
`;

export default SecondaryButton;
